import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { AdminGuard } from './authorizations/admin.guard';
import { SuperAdminGuard } from './authorizations/super-admin.guard';
import { ViewerGuard } from './authorizations/viewer.guard';

const routes: Routes = [
  {
    path: 'lookup',
    loadChildren: () =>
      import('./features/lookup/lookup.module').then((m) => m.LookupModule),
    canActivate: [MsalGuard, ViewerGuard],
  },
  {
    path: 'create',
    loadChildren: () =>
      import('./features/create/create.module').then((m) => m.CreateModule),
    canActivate: [MsalGuard, AdminGuard],
  },
  {
    path: 'update',
    loadChildren: () =>
      import('./features/update/update.module').then((m) => m.UpdateModule),
    canActivate: [MsalGuard, AdminGuard],
  },
  {
    path: 'delete',
    loadChildren: () =>
      import('./features/delete/delete.moudle').then((m) => m.DeleteModule),
    canActivate: [MsalGuard, SuperAdminGuard],
  },
  {
    path: 'restore',
    loadChildren: () =>
      import('./features/restore/restore.module').then((m) => m.RestoreModule),
    canActivate: [MsalGuard, AdminGuard],
  },
  {
    path: 'settings',
    loadChildren: () =>
      import('./features/settings/settings.module').then(
        (m) => m.SettingsModule
      ),
    canActivate: [MsalGuard, SuperAdminGuard],
  },
  {
    // Needed for hash routing
    path: 'error',
    loadChildren: () =>
      import('./features/home/home.module').then((m) => m.HomeModule),
  },
  {
    // Needed for hash routing
    path: 'state',
    loadChildren: () =>
      import('./features/home/home.module').then((m) => m.HomeModule),
  },
  {
    // Needed for hash routing
    path: 'code',
    loadChildren: () =>
      import('./features/home/home.module').then((m) => m.HomeModule),
  },
  {
    path: '',
    loadChildren: () =>
      import('./features/home/home.module').then((m) => m.HomeModule),
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: true,
      scrollPositionRestoration: 'enabled',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
